import React from 'react';
import { v4 as uuid } from 'uuid';
import { SYNC_SPEAKERS_HIDE_BIO_BTN_TEXT, SYNC_SPEAKERS_VIEW_BIO_BTN_TEXT } from '../sync-speakers-constants';

interface IProps {
    content: string;
    openByDefault?: boolean;
    onToggleAccordion?: () => void;
}

const SpeakerBioAccordion: React.FC<IProps> = ({ content, openByDefault, onToggleAccordion }) => {
    const uniqueGroupId: string = uuid();
    const onChangeAccordionState = (): void => {
        if (onToggleAccordion) {
            onToggleAccordion();
        }
    };

    return !!content ? (
        <div className='speaker-bio-accordion'>
            <input
                type='radio'
                name={`accoordion_${uniqueGroupId}`}
                className='expand-radio-btn'
                radioGroup={`accoordion_${uniqueGroupId}`}
                id={`expand_btn_${uniqueGroupId}`}
                defaultChecked={openByDefault}
            />
            <input
                type='radio'
                name={`accoordion_${uniqueGroupId}`}
                className='collapse-radio-btn'
                radioGroup={`accoordion_${uniqueGroupId}`}
                id={`collapse-btn_${uniqueGroupId}`}
                defaultChecked={!openByDefault}
            />
            <label
                htmlFor={`expand_btn_${uniqueGroupId}`}
                className='speaker-bio-accordion__btn-title'
                id='show-bio-title'
                onClick={onChangeAccordionState}
            >{SYNC_SPEAKERS_VIEW_BIO_BTN_TEXT}</label>
            <div className='speaker-bio-accordion__content'>
                <div className='content-block' dangerouslySetInnerHTML={{__html: content}} />
                <label
                    htmlFor={`collapse-btn_${uniqueGroupId}`}
                    className='speaker-bio-accordion__btn-title'
                    id='hide-bio-title'
                    onClick={onChangeAccordionState}
                >{SYNC_SPEAKERS_HIDE_BIO_BTN_TEXT}</label>
            </div>
        </div>
    ) : null;
};

export { SpeakerBioAccordion };
